import { render, staticRenderFns } from "./subjectApplicaAnaly.vue?vue&type=template&id=2db8fad8&scoped=true"
import script from "./subjectApplicaAnaly.vue?vue&type=script&lang=js"
export * from "./subjectApplicaAnaly.vue?vue&type=script&lang=js"
import style0 from "./subjectApplicaAnaly.vue?vue&type=style&index=0&id=2db8fad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db8fad8",
  null
  
)

export default component.exports